export function resolveActivityHistoryOnlyCurrentUser(isOwner: boolean | undefined): boolean {
  return isOwner !== true;
}

export type DeleteAccountPolicyInput = {
  entLoading: boolean;
  entitlements: { is_owner?: boolean } | null;
  entitlementsLoadMissing: boolean;
  offlineOwnerHint?: boolean | null;
};

export function resolveDeleteAccountBlocked(input: DeleteAccountPolicyInput): boolean {
  if (input.entLoading && !input.entitlements) return true;
  if (input.entitlementsLoadMissing && input.offlineOwnerHint !== true) return true;
  return false;
}

export function resolveCloseBusinessBlockedDescription(blocked: boolean, entLoading: boolean): string {
  if (!blocked) return 'Cerrás el negocio y se oculta de la tienda online. Seguís comprando en el portal.';
  if (entLoading) return 'Esperá a que carguen los datos de tu cuenta.';
  return 'Reintentá cargar los datos del negocio antes de cerrarlo.';
}

export function resolveRevokeEmployeeBlockedDescription(blocked: boolean, entLoading: boolean): string {
  if (!blocked) return 'Sacás tu acceso a este negocio. Seguís comprando en el portal.';
  if (entLoading) return 'Esperá a que carguen los datos de tu cuenta.';
  return 'Reintentá cargar los datos del negocio antes de sacar tu acceso.';
}
